import { useEffect, useState } from 'react';
import { agenciesApi, type AgencyClient } from '../../../api/agencies.api';

const DEBOUNCE_MS = 250;

/** The agency's clients matching `query`, asked for once the typing pauses. */
export function useClientSearch(agencyId: string, query: string, version = 0) {
  const [result, setResult] = useState<{ key: string; clients: AgencyClient[] } | null>(null);
  const key = `${query.trim()}:${version}`;

  useEffect(() => {
    let cancelled = false;
    const timer = setTimeout(() => {
      agenciesApi.clients(agencyId, query.trim() || undefined)
        .then(clients => { if (!cancelled) setResult({ key, clients }); })
        .catch(() => { if (!cancelled) setResult({ key, clients: [] }); });
    }, query.trim() ? DEBOUNCE_MS : 0);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [agencyId, query, key]);

  return { clients: result?.clients ?? [], loading: result?.key !== key };
}
